/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Rule_Support_DescInputs */



/**
* | output |
* | --- |
* | "Preparation, coaching and follow-up for this conversation" |
*
* @param {Meetings_Exception_Rule_Support_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_rule_support_desc = /** @type {((inputs?: Meetings_Exception_Rule_Support_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Rule_Support_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voorbereiding, coaching en opvolging voor dit gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation, coaching et suivi pour cette conversation")
	return /** @type {LocalizedString} */ ("Preparation, coaching and follow-up for this conversation")
});